import { Component, HostListener, ElementRef, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { NgForm } from '@angular/forms';


 
@Component({
  selector: 'app-home-three',
  templateUrl: './home-three.component.html',
  styleUrl: './home-three.component.css'
})
export class HomeThreeComponent {

  private apiUrl = environment.apiUrl; // ✅ environment variable

   @ViewChild('contactForm') contactForm!: NgForm;

  //private apiUrl = 'http://localhost:3001/apiMailService';
  // Floating Vedha Image
  @ViewChild('floatingVedha', { static: false }) floatingVedha!: ElementRef;
  vedhaTransform: string = 'translateY(0px) rotate(0deg) scale(1)';
  vedhaOpacity: number = 1;

  private animationFrameId?: number;
  private floatingAnimationId?: number;

    // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };


 
  sending = false;
  successMsg = '';
  errorMsg = '';
  constructor(private http: HttpClient){

  }

  ngOnInit(): void {
    // Start the floating animation immediately
    this.startFloatingAnimation();
    // Start the typing animation
    this.startTyping();


    document.addEventListener('DOMContentLoaded', () => {
      const el = document.getElementById('heroVideo');
      if (el instanceof HTMLVideoElement) {
        this.setupAutoplay(el);
      }
    });

    
  }





  setupAutoplay(video: HTMLVideoElement): void {
  video.muted = true;          // required for mobile autoplay
  video.autoplay = true;
  video.loop = true;
  (video as any).playsInline = true; // property for iOS Safari

  const tryPlay = () =>
    video.play().catch(() => {
      // If autoplay is blocked, show controls so user can start it
      video.setAttribute('controls', '');
    });

  if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
    void tryPlay();
  } else {
    video.addEventListener('loadeddata', () => void tryPlay(), { once: true });
  }
}




  async sendMessage(data: any){
    
    if (this.sending) return; // prevent double-clicks
    this.sending = true;
    this.successMsg = '';
    this.errorMsg = '';
    // Example: return an Observable from HttpClient  
     data.SMTP_HOST = environment.SMTP_HOST,
     data.SMTP_USER = environment.SMTP_USER,
     data.SMTP_PASS = environment.SMTP_PASS,
     data.SMTP_PORT = environment.SMTP_PORT,
     data.domainURL = environment.domainURL,
     data.subject = 'Contact Form' 
    const response: any = await firstValueFrom(this.http.post(this.apiUrl + "/contact", data));
    //console.log(response, 'message')
    if(response.status == "Okay"){
      this.sending = false;     
       this.successMsg =  '✅ Message sent successfully!';
        setTimeout(() => {
          this.successMsg = '';
        }, 2000);       
             // ✅ Reset form + values + validation state
         this.resetForms()
        // ⏳ Clear success message after 5 seconds
           
      
    }else{
        this.sending = false;
        this.errorMsg =  '❌ Failed to send message.';
          setTimeout(() => {
           this.errorMsg = '';
        }, 2000);
    }
  }

 

  ngOnDestroy(): void {
    // Clean up animations
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    if (this.floatingAnimationId) {
      cancelAnimationFrame(this.floatingAnimationId);
    }
  }

  private startFloatingAnimation(): void {
    const animate = () => {
      this.updateFloatingVedha();
      this.floatingAnimationId = requestAnimationFrame(animate);
    };
    animate();
  }

  // Video Player
  isMuted: boolean = true; // Start with the video muted

  toggleMute(): void {
    this.isMuted = !this.isMuted;
  }

  // How AskVedha Works
  steps = [
    {
      icon:"fas fa-question secondary-color font-30px",
      title:"Ask Your Question",
      desc:"Simply type or speak your question from any textbook or homework assignment."
    },
    {
      icon:"fas fa-brain secondary-color font-30px",
      title:"AI Processing",
      desc:"Our advanced AI analyzes your question and finds the best way to explain it for your grade level."
    },
    {
      icon:"fas fa-lightbulb secondary-color font-30px",
      title:"Get Clear Answer",
      desc:"Receive an easy-to-understand explanation with examples and step-by-step solutions."
    },
    {
      icon:"fas fa-graduation-cap secondary-color font-30px",
      title:"Learn & Grow",
      desc:"Build confidence and understanding as you master new concepts with AskVedha's help."
    },
  ]

  // Type it
  phrases: string[] = ['Math Problems', 'Science Questions', 'History Facts', 'English Grammar', 'Study Help'];
  displayedText: string = ''; 
  currentPhraseIndex: number = 0; 
  currentIndex: number = 0; 
  typingSpeed: number = 100; 
  delayBetweenPhrases: number = 1500; 



  startTyping(): void {
    this.typePhrase();
  }

  typePhrase(): void {
    const phrase = this.phrases[this.currentPhraseIndex];

    const typingInterval = setInterval(() => {
      if (this.currentIndex < phrase.length) {
        this.displayedText += phrase.charAt(this.currentIndex);
        this.currentIndex++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          this.startDeleting();
        }, this.delayBetweenPhrases); // Delay before starting to delete
      }
    }, this.typingSpeed);
  }

  startDeleting(): void {
    const deletingInterval = setInterval(() => {
      if (this.currentIndex > 0) {
        this.displayedText = this.displayedText.slice(0, -1);
        this.currentIndex--;
      } else {
        clearInterval(deletingInterval);
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length;
        this.currentIndex = 0;
        setTimeout(() => {
          this.typePhrase();
        }, this.delayBetweenPhrases); // Delay before starting to type the next phrase
      }
    }, this.typingSpeed / 2); // Faster deleting speed
  }

  // Educational Team

  slideStoreTwo: { title: string; subtitle: string; image: string; index: number }[] = [
    {
      title: "",
      subtitle: "",
      image: "student1.webp",
      index: 0
    },
    {
      title: "",
      subtitle: "",
      image: "student2.webp",
      index: 1
    },
    {
      title: "",
      subtitle: "",
      image: "student3.webp",
      index: 2
    },
    // {
    //   title: "",
    //   subtitle: "",
    //   image: "albert.webp",
    //   index: 3
    // }
  ];

  socialLinks = [
    { iconOuter: "facebook", iconInner: ['icofont icofont-social-facebook'] },
    { iconOuter: "twitter", iconInner: ['icofont icofont-social-twitter'] },
    { iconOuter: "pinterest", iconInner: ['icofont icofont-social-pinterest'] },
  ];

  // Educational Services
  services = [
    {
      icon: "fas fa-calculator font-30px white-color",
      title: "Mathematics",
      desc: "From basic arithmetic to advanced calculus, get step-by-step solutions and explanations for all math problems.",
    },
    {
      icon: "fas fa-flask font-30px white-color",
      title: "Science",
      desc: "Explore physics, chemistry, and biology concepts with interactive explanations and real-world examples.",
    },
    {
      icon: "fas fa-book-open font-30px white-color",
      title: "English & Literature",
      desc: "Improve reading comprehension, grammar, writing skills, and analyze literary works with AI guidance.",
    },
    {
      icon: "fas fa-globe font-30px white-color",
      title: "Social Studies",
      desc: "Learn about history, geography, civics, and cultures with engaging stories and visual explanations.",
    },
    {
      icon: "fas fa-language font-30px white-color",
      title: "Languages",
      desc: "Master new languages with pronunciation guides, grammar rules, and interactive conversation practice.",
    },
    {
      icon: "fas fa-puzzle-piece font-30px white-color",
      title: "Critical Thinking",
      desc: "Develop problem-solving skills and logical reasoning through guided practice and brain teasers.",
    },
  ]

  // AskVedha Capabilities
  skills = [
    { name: 'Mathematics', level: 95 },
    { name: 'Science', level: 92 },
    { name: 'English', level: 88 },
    { name: 'Social Studies', level: 85 },
    { name: 'Languages', level: 80 }
  ];

  isScrolled = false;

  @HostListener('window:scroll', [])
  onScroll(): void {
    // Cancel previous animation frame to prevent stacking
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }

    // Use requestAnimationFrame for smooth updates
    this.animationFrameId = requestAnimationFrame(() => {
      const skillsSection = document.querySelector('.skill');
      if (skillsSection) {
        const position = skillsSection.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (position < windowHeight) {
          this.isScrolled = true;
        }
      }
      // Don't call updateFloatingVedha here since it's already running continuously
    });
  }

  private updateFloatingVedha(): void {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Enhanced floating animation with more movement
    const time = Date.now() * 0.001;
    const floatY = Math.sin(time) * 25 + Math.sin(time * 1.5) * 10;
    const floatX = Math.sin(time * 0.8) * 18 + Math.cos(time * 1.2) * 8;
    const rotation = Math.sin(time * 0.6) * 3;

    // Parallax with scroll
    const parallaxY = scrollY * 0.03;
    const maxParallax = windowHeight * 0.2;
    const finalParallaxY = Math.min(parallaxY, maxParallax);

    const finalY = finalParallaxY + floatY;
    const finalX = floatX;

    // Opacity
    const scrollProgress = scrollY / (documentHeight - windowHeight);
    const opacity = Math.max(0.9, 1 - scrollProgress * 0.1);

    // Enhanced transform with rotation and scale variation
    const scale = 1 + Math.sin(time * 0.4) * 0.05;
    this.vedhaTransform = `translate3d(${finalX}px, ${finalY}px, 0) rotate(${rotation}deg) scale(${scale})`;
    this.vedhaOpacity = opacity;
  }

  // Portfolio
  portfolios = [
    {
      img: "newton.webp",
      title: "Fode ",
      subTitle: "Branding, Mockup"
    },
    {
      img: "kalam.webp",
      title: "Daniel and Denise",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "albert.webp",
      title: "Sydney Design",
      subTitle: "Design, Stationery"
    },
    {
      img: "arya.webp",
      title: "Glasses",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "Kalpana.webp",
      title: "The Bijou Factory",
      subTitle: "Branding, Mockup"
    },
    {
      img: "Mahatma.webp",
      title: "Calender",
      subTitle: "Design, Branding"
    },
    {
      img: "Nehru.webp",
      title: "Flyer",
      subTitle: "Branding, Stationery"
    },
    {
      img: "Nikola.webp",
      title: "Hand Watch",
      subTitle: "Design, UI/UX"
    },
    {
      img: "Srinivasa.webp",
      title: "Flyer",
      subTitle: "Branding, Stationery"
    },
    {
      img: "Thomas.webp",
      title: "Hand Watch",
      subTitle: "Design, UI/UX"
    },
    {
      img: "Vidai-AI-Robot.webp",
      title: "Hand Watch",
      subTitle: "Design, UI/UX"
    }
  ]

  // Educational Pricing Plans
  pricing = [
    {
      title: "Student Plan",
      subTitle: "Perfect for individual students who need homework help and study support.",
      currency: "$",
      amount: 4.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Start Learning",
      features: [
        'Unlimited Questions',
        'All School Subjects',
        'Step-by-Step Solutions',
        'Grade-Appropriate Answers',
        'Mobile & Web Access',
        'Basic Study Tools',
        'Email Support',
        'Safe Learning Environment'
      ]
    },

    {
      title: "Family Plan",
      subTitle: "Ideal for families with multiple children in different grades.",
      currency: "$",
      amount: 12.99,
      btnClass: "btn btn-gradient-secondary btn-md btn-default btn-square",
      btnText: "Choose Family",
      features: [
        'Up to 4 Student Accounts',
        'All Subjects & Grades',
        'Advanced Study Tools',
        'Progress Tracking',
        'Parent Dashboard',
        'Priority Support',
        'Offline Study Materials',
        'Custom Learning Paths'
      ]
    },

    {
      title: "School Plan",
      subTitle: "Comprehensive solution for schools and educational institutions.",
      currency: "$",
      amount: 99.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Contact Sales",
      features: [
        'Unlimited Student Accounts',
        'Teacher Dashboard',
        'Classroom Management',
        'Custom Curriculum Support',
        'Analytics & Reports',
        'API Integration',
        'Dedicated Support',
        'Training & Onboarding'
      ]
    }
  ];

  // Owl Testimonial
  customOptionsThree: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:3,
      }
    }
  }

  slideStoreThree = [
    {
      title: "Emma Johnson",
      subTitle: "8th Grade Student",
      description: "AskVedha helped me understand algebra so much better! Now I can solve equations on my own and my grades have improved a lot.",
      image: "assets/images/team/avatar-1.jpg",
    },

    {
      title: "Mrs. Sarah Wilson",
      subTitle: "Middle School Teacher",
      description: "AskVedha is an excellent learning companion for my students. It provides clear explanations that complement our classroom teaching perfectly.",
      image: "assets/images/team/avatar-2.jpg",
    },

    {
      title: "David Chen",
      subTitle: "Parent",
      description: "My daughter uses AskVedha for homework help every day. It's like having a patient tutor available 24/7. Her confidence in learning has grown tremendously.",
      image: "assets/images/team/avatar-3.jpg",
    },

    {
      title: "Alex Rodriguez",
      subTitle: "10th Grade Student",
      description: "Science was my weakest subject until I started using AskVedha. The step-by-step explanations make complex concepts easy to understand.",
      image: "assets/images/team/avatar-4.jpg",
    }

  ]

  // Owl Brand Logos
  customOptionsFour: OwlOptions = {
    loop: true,
    dots: false,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:6,
      }
    }
  }

  slideStoreFour = [
    {
      image: "assets/images/clients/1.png",
    },

    {
      image: "assets/images/clients/2.png",
    },

    {
      image: "assets/images/clients/3.png",
    },

    {
      image: "assets/images/clients/4.png",
    },

    {
      image: "assets/images/clients/5.png",
    },

    {
      image: "assets/images/clients/6.png",
    }

  ]



  // EmailJS service configuration
  private serviceId = 'contact-form';  // Replace with your EmailJS Service ID
  private templateId = 'contact-form-becki';  // Replace with your EmailJS Template ID
  private publicKey = 'gObMl0a3V0Jib9k5c';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  socialMedia = [
    {
      iconClass: "icon facebook",
      icon:"icofont icofont-social-facebook",
      link:'https://www.facebook.com/'
    },
    {
      iconClass: "icon twitter",
      icon:"icofont icofont-social-twitter",
      link:'https://x.com/'
    },
    // {
    //   iconClass: "icon behance",
    //   icon:"icofont icofont-social-behance"
    // },
    {
      iconClass: "icon linkedin",
      icon:"icofont icofont-social-linkedin",
      link:'https://in.linkedin.com/'
    },
    {
      iconClass: "icon youtube",
      icon:"icofont icofont-social-youtube",
      link:'https://www.youtube.com/'
    },
    {
      iconClass: "icon instagram",
      icon:"icofont icofont-social-instagram",
      link:'https://www.instagram.com/vedha_verse?igsh=MjU3MnM1cDgwMml3&utm_source=qr'
    }
  ]

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }


  resetForms() {
    // ✅ Reset values + validation state
    this.contactForm.resetForm({
      user_name: '',
      user_email: '',
      message: ''
    });
  }
}


